<template>
  <div class="backgroud-white cs-splitCourse-container">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-row>
        <el-col :span="4">课程:</el-col>
        <el-col :span="16">{{dataIn.courseName}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="4">人数:</el-col>
        <el-col :span="16">{{studentTotalCount}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="cs-splitCourse-numberLeft">
            <el-input-number
              size="small"
              v-model="studentCountLeft"
              @change="handleStudentCountLeftChange"
              :min="1"
              :max="studentTotalCount"
              label="分班1"
            ></el-input-number>
          </div>
          <div class="cs-splitCourse-numberRight">
            <el-input-number
              size="small"
              v-model="studentCountRight"
              @change="handleStudentCountRightChange"
              :min="1"
              :max="studentTotalCount"
              label="分班2"
            ></el-input-number>
          </div>
          <div class="cs-splitCourse-numberButton">
            <el-button
              type="primary"
              size="small"
              @click="confirmStudentCount"
            >确认</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-transfer
            v-model="selectedStudentList"
            :data="transferStudentList"
            :render-content="renderOption"
            @change="onSelectedStudentListChange"
          ></el-transfer>
        </el-col>
      </el-row>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          class="footer-right"
          :span="24"
        >
          <el-button
            :disabled="submitBtnDisable"
            type="primary"
            @click="save()"
          >保存分班</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-splitCourse-container{
    
  .el-row{
    margin-bottom: 10px;
  }

  .cs-splitCourse-numberLeft{
    display: inline-block;
    width: 360px;
  }
  .cs-splitCourse-numberRight{
    display: inline-block;
     width: 180px;
  }
  .cs-splitCourse-numberButton{
    display: inline-block;
  }
}

</style>

<style lang="scss">
  .el-transfer-panel{
    width: 260px;
  }
</style>

<script>
import {
  separateCourse,
  getScheduleStudentList
} from "../../service/speedupCourse.service";
export default {
  data() {
    return {
      studentCountLeft: 1,
      studentCountRight: 1,
      scheduleStudentList: [],
      transferStudentList: [],
      selectedStudentList: [],
      studentTotalCount: 1,
      submitBtnDisable: false
    };
  },
  components: {},
  props: {
    dataIn: {
      termId: Number,
      planId: Number,
      courseName: String,
      courseId: Number,
      teacherId: Number,
      courseClass: Number,
      unavailaleStudentList: Array
    }
  },
  created() {
    this.init();
  },
  methods: {
    renderOption(h, option) {
      let text = "";
      if (option.isUnavailable) {
        text = "不可用";
         return (<span>{ option.label }(<label class="cs-redLabel">{ text }</label>)</span>);
      } else {
        text = "可用";
        return (<span>{ option.label }(<label>{ text }</label>)</span>);
      }
    },
    init() {
      this.submitBtnDisable = false;
      this.loadStudentList();
    },
    loadStudentList() {
      getScheduleStudentList(
        this.dataIn.termId,
        this.dataIn.planId,
        this.dataIn.courseId,
        this.dataIn.teacherId,
        this.dataIn.courseClass
      ).then(result => {
        if (!!result && result.success) {
          this.scheduleStudentList = result.data;
          this.loadTransferStudentList();
        }
      });
    },
    loadTransferStudentList() {
      this.transferStudentList = this.scheduleStudentList.map(i => {
        let text = "";
        let unavailableStudent = this.dataIn.unavailaleStudentList.filter(
          j => (j.StudentId == i.StudentId)
        );
        let isUnavailable = false;
        if (unavailableStudent.length > 0) {
          isUnavailable = true;
        } 
        text = i.StudentName;
        return {
          key: i.StudentId,
          label: text,
          isUnavailable: isUnavailable,
          disabled: false
        };
      });
      this.studentTotalCount = this.scheduleStudentList.length;
      this.selectedStudentList = this.dataIn.unavailaleStudentList.map(
        i => i.StudentId
      );
      this.studentCountRight = this.dataIn.unavailaleStudentList.length;
      this.studentCountLeft = this.studentTotalCount - this.studentCountRight;
    },
    handleStudentCountLeftChange() {
      this.studentCountRight = this.studentTotalCount - this.studentCountLeft;
    },
    handleStudentCountRightChange() {
      this.studentCountLeft = this.studentTotalCount - this.studentCountRight;
    },
    confirmStudentCount() {
      let list = [];
      for (let i = 0; i < this.dataIn.unavailaleStudentList.length; i++) {
        if (i < this.studentCountRight) {
          list.push(this.dataIn.unavailaleStudentList[i].StudentId);
        } else {
          break;
        }
      }
      if (this.studentCountRight > this.dataIn.unavailaleStudentList.length) {
        let count = 0;
        for (let i = 0; i < this.scheduleStudentList.length; i++) {
          let item = this.scheduleStudentList[i];
          let index = this.selectedStudentList.indexOf(item.StudentId);
          if (index < 0) {
            list.push(item.StudentId);
            count++;
          }
          if (list.length >= this.studentCountRight) {
            break;
          }
        }
      }

      this.selectedStudentList = list;
    },
    onSelectedStudentListChange(){
      this.studentCountRight = this.selectedStudentList.length;
      this.studentCountLeft = this.studentTotalCount - this.studentCountRight;
    },
    save() {
      this.submitBtnDisable = true;
      separateCourse(
        this.dataIn.termId,
        this.dataIn.planId,
        this.dataIn.courseId,
        this.dataIn.teacherId,
        this.dataIn.courseClass,
        this.selectedStudentList
      ).then(result => {
        if (result.success) {
          this.$message({
            message: "分班成功",
            type: "success"
          });
          this.$emit("splitSuccess");
        } else {
          if (result.message) {
            this.$message({
              message: result.message,
              type: "warning"
            });
          }
        }
      });
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCourseSplit.vue